/** Contenido editable de Calculadoras (Firestore site/calculadoras). */

export const CALCULATORS_CMS_DOC = { collection: "site", id: "calculadoras" };

export function defaultCalculatorsCms() {
  return {
    page: {
      title: "Calculadoras",
      titleHighlight: "Técnicas SSO",
      subtitle: "Herramientas de precisión para higiene industrial y vigilancia epidemiológica.",
    },
    ruido: {
      diagnostics: {
        seguro:
          "Nivel SEGURO. No se requieren acciones correctivas inmediatas. Continuar con monitoreo preventivo.",
        accion:
          "Nivel de ACCIÓN alcanzado. Se recomienda vigilancia de la salud (audiometrías), capacitación y uso de EPP.",
        excedido:
          "Nivel EXCEDIDO. Uso de protección auditiva (EPP) OBLIGATORIO. Se requiere implementación inmediata de controles de ingeniería.",
      },
      protocols: {
        niosh: {
          name: "NIOSH / ACGIH",
          desc: "Basado en criterios científicos de salud para prevenir la pérdida auditiva. Utiliza una tasa de intercambio de 3dB y un límite estricto de 85dB. Recomendado para excelencia en SSO.",
        },
        eu: {
          name: "ISO / Europa / ES",
          desc: "Normativa basada en la ISO 9612. Utiliza una tasa de intercambio de 3dB y establece un Nivel de Acción inferior (80dB) para iniciar medidas preventivas técnicas.",
        },
        osha: {
          name: "OSHA / MSHA",
          desc: "Estándar Federal de cumplimiento legal en EE.UU. Utiliza una tasa de intercambio de 5dB. Es el modelo más permisivo, diseñado para cumplimiento regulatorio básico.",
        },
      },
      footerNote:
        "Los cálculos se basan en un criterio de 85dB para 8 horas. Para niveles de impacto (picos), se recomienda una evaluación con sonómetro de integración.",
    },
    calor: {
      riskLabels: {
        seguro: "Seguro",
        precaucion: "Precaución",
        peligro: "Peligro: Exceso de Límite",
      },
    },
  };
}

function str(v, fallback = "") {
  const s = String(v ?? "").trim();
  return s || fallback;
}

export function mergeCalculatorsCms(raw) {
  const d = defaultCalculatorsCms();
  const src = raw && typeof raw === "object" ? raw : {};
  const page = src.page && typeof src.page === "object" ? src.page : {};
  const ruido = src.ruido && typeof src.ruido === "object" ? src.ruido : {};
  const calor = src.calor && typeof src.calor === "object" ? src.calor : {};
  const diag =
    ruido.diagnostics && typeof ruido.diagnostics === "object" ? ruido.diagnostics : {};
  const prots =
    ruido.protocols && typeof ruido.protocols === "object" ? ruido.protocols : {};
  const risk =
    calor.riskLabels && typeof calor.riskLabels === "object" ? calor.riskLabels : {};

  const mergeProtocol = (key) => {
    const base = d.ruido.protocols[key];
    const extra = prots[key] && typeof prots[key] === "object" ? prots[key] : {};
    return {
      name: str(extra.name, base.name),
      desc: str(extra.desc, base.desc),
    };
  };

  return {
    page: {
      title: str(page.title, d.page.title),
      titleHighlight: str(page.titleHighlight, d.page.titleHighlight),
      subtitle: str(page.subtitle, d.page.subtitle),
    },
    ruido: {
      diagnostics: {
        seguro: str(diag.seguro, d.ruido.diagnostics.seguro),
        accion: str(diag.accion, d.ruido.diagnostics.accion),
        excedido: str(diag.excedido, d.ruido.diagnostics.excedido),
      },
      protocols: {
        niosh: mergeProtocol("niosh"),
        eu: mergeProtocol("eu"),
        osha: mergeProtocol("osha"),
      },
      footerNote: str(ruido.footerNote, d.ruido.footerNote),
    },
    calor: {
      riskLabels: {
        seguro: str(risk.seguro, d.calor.riskLabels.seguro),
        precaucion: str(risk.precaucion, d.calor.riskLabels.precaucion),
        peligro: str(risk.peligro, d.calor.riskLabels.peligro),
      },
    },
  };
}
